module.exports = __webpack_public_path__ + "static/media/26 Body Triangle.4bca0813.jpg";